import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosGet, axiosPost, axiosGetMdms } from './axiosUtils';
import './axiosInterceptor';

const MDMSService = {
  async getMDMSUserData(user: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`mdms`, user);
  },

  async getAboSponsorData(campaignId: string): AxiosUtilsType {
    return await axiosGetMdms(`mdms/getCalculateNewAboCount/${campaignId}`);
  },

  async getUpdatePointData(campaignId: string): AxiosUtilsType {
    return await axiosPost(`updatePoint/${campaignId}`);
  },

  async getLastPointCountDate(campaignId: string): AxiosUtilsType {
    return await axiosGet(`/getLastPointCountDate/${campaignId}`);
  },
};

export default MDMSService;
